
import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

// Update document title based on current route
// Update document title based on current route
const updateTitle = (pathname: string) => {
  const routeTitles: { [key: string]: string } = {
    '/': 'Ana Sayfa',
    '/hakkimizda': 'Biz Kimiz',
    '/faaliyetlerimiz': 'Faaliyetlerimiz',
    '/duyurular': 'Duyurular',
    '/hukuki-bilgiler': 'Pratik Bilgiler',
    '/ortak-kuruluslar': 'Anlaşmalı Kuruluşlar',
    '/kvkk': 'KVKK Aydınlatma Metni',

    // 🎄 YILBAŞI PARTİSİ
    '/party': 'Yılbaşı Partisi'
  };

  let title = 'Ana Sayfa';

  if (pathname.startsWith('/duyuru-detay/')) {
    title = 'Duyuru Detayı';
  } else if (pathname.startsWith('/etkinlik-detay/')) {
    title = 'Etkinlik Detayı';
  } else if (pathname.startsWith('/kilavuz-detay/')) {
    title = 'Kılavuz Detayı';
  } else if (routeTitles[pathname]) {
    title = routeTitles[pathname];
  }

  document.title = `Genç Savunma | ${title}`;
};


export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
    
    // Update title on route change
    updateTitle(window.location.pathname);
  }, [navigate]);
  
  return element;
}
